import classnames from 'classnames';
import { motion, useAnimationControls } from 'framer-motion';
import React, { FC, useState, useRef, useEffect } from 'react';
import style from '@/presentation/pages/main-pro/features.module.scss';

export interface ISegmentedList {
  txt: string;
  img: [string, string, string]
}
interface IProps {
  title: string;
  segmentedList: ISegmentedList[];
  className?: string;
}
export const Features: FC<IProps> = (props: IProps) => {
  const [checked, setChecked] = useState(0);
  const segmentedGroupRef = useRef<HTMLDivElement>(null);
  const controls = useAnimationControls();
  const { segmentedList, className, title } = props;
  useEffect(() => {
    const item = segmentedGroupRef?.current?.querySelectorAll<HTMLDivElement>('.segmented-label')[checked];
    controls.start({
      y: item?.offsetTop,
      height: item?.offsetHeight,
    });
  }, []);

  const hover =  (index: number) => {
    try {
      const beforeItem = segmentedGroupRef?.current?.querySelectorAll<HTMLDivElement>('.segmented-label')?.[index];
      controls.start({
        y: beforeItem?.offsetTop || 0,
        height: beforeItem?.offsetHeight || 0,
      }, {
        duration: 0.2,
      });
      setChecked(index);
    } catch (e) {

    }
  };

  return <div className={classnames(style.features, className) }>
    <div className={style.featuresContent}>
      <div>
        <div className={style.featuresContentTitle}>{title}</div>
        <div  ref={segmentedGroupRef} className={style.segmentedGroup}>
          {<motion.div animate={controls} className={style.segmentedControl}/>}
          {segmentedList.map((item, index) => <div key={index} onMouseOver={(e) => {
            e.preventDefault();
            e.stopPropagation();
            hover(index);
          }} className={classnames(style.segmentedLabel, 'segmented-label')}>
              <div className={style.segmentedTxt}>{item.txt}</div>
            </div>)}
        </div>
      </div>
    </div>
    <div>
      <motion.div
        key={checked}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 40, opacity: 0 }}
        transition={{ duration: 1, type: 'spring' }}
      >
        {segmentedList.map((item, index) => <img className={classnames({ [style.featuresImg]: true, [style.featuresImgActive]: index === checked })} srcSet={`${item.img[0]} 1x, ${item.img[1]} 2x, ${item.img[2]} 3x`} alt=''/>)}
      </motion.div>
      </div>
  </div>;
};


